import { Box } from "@mui/material";
import { useContext, useState } from "react";
import { OrganizationMenu } from "./organizationMenu";
import { EditOrganizationForm } from "./editOrganizationForm";
import { EditMailingPermitForm } from "./editMailingPermitForm";
import { AddClientForm } from "./addClientForm";
import { UpdateLogoForm } from "./updateLogoForm";
import { OrganizationContext } from "../../../context/organizationContext";
import { AppUserContext } from "../../../context/appUserContext";




export function OrganizationHeader() {

    const [showEditOrganization, setShowEditOrganization] = useState(false);
    const [showEditOrgMailingPermit, setShowEditOrgMailingPermit] = useState(false);
    const [showAddClient, setAddClient] = useState(false);
    const [showUpdateLogo, setShowUpdateLogo] = useState(false);
    const [showProductForm, setShowProductForm] = useState(false);

    const { appUser } = useContext(AppUserContext);
    const { organization, updateOrganization, updateMailingPermit,addClient, updateLogo} = useContext(OrganizationContext);

    
    function clickEditHandler(){
        setShowEditOrganization(true);
    }

    function clickEditMailingPermitHandler(){
        setShowEditOrgMailingPermit(true);
    }

    function clickAddClientHandler(){
        setAddClient(true);
    }

    function clickUpdateLogoHandler(){
        setShowUpdateLogo(true);
    }

    function clickShowProductHandler(){
      setShowProductForm(true);
  }


    return (
        <Box>
             <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            border: "2px solid #cecece",
                            cursor: "pointer",
                            alignItems: "center",
                            borderRadius: 5,
                            padding: 1,
                            margin:1
                          }}
                        >

                          <Box  sx={{height:'100px'}} component='img' src={organization?.logoLink} alt='' />

                          <Box sx={{ diplay: "flex", flexDirection: "column" }}>
                            <h1>{organization?.name} Dashboard</h1>
                          </Box>


                          <Box sx={{ diplay: "flex", flexDirection: "column" }}>
                            
                            <OrganizationMenu 
                                              organizationId={organization?.orgId ?? 0}
                                              onClickEdit={clickEditHandler} 
                                              onClickEditMailingPermit = {clickEditMailingPermitHandler}
                                              onClickAddClient={clickAddClientHandler}
                                              onClickUpdateLogo={clickUpdateLogoHandler}
                                              onClickShowProductForm={clickShowProductHandler} />
                                              </Box>
                              
                        </Box>

                        <EditOrganizationForm open={showEditOrganization} 
                                              organization={organization} 
                                              onClose={() => setShowEditOrganization(false)} 
                                              userName={appUser?.appUserName ?? ""}
                                              onUpdate={updateOrganization} />

                          <EditMailingPermitForm open={showEditOrgMailingPermit} 
                                              mailingPermit={organization?.mailingPermit} 
                                              mailingPermitError=""
                                              onClose={() => setShowEditOrgMailingPermit(false)} 
                                              userName={appUser?.appUserName ?? ""}
                                              onUpdate={updateMailingPermit} />

                          <AddClientForm open={showAddClient}
                                              onClose={() => setAddClient(false)}
                                              onUpdate={addClient}
                                              userName={appUser?.appUserName ?? ""}
                                              client={undefined}/>

                          <UpdateLogoForm open={showUpdateLogo} 
                                              onClose={() => setShowUpdateLogo(false)}
                                              onUpdate={updateLogo} />

        </Box>
    );
}